<template>
    <div>
        <template v-if="isPageAllowed">
            <div class="wrap full-h">
                <div class="left full-h" style="height: calc(100vh - 80px);">
                    <CompanyListCard ref="companyListCard" @checked="changeCustomer" :active-item="activeCustomer" />
                </div>
                <div class="right pl10 full-h" style="height: calc(100vh - 80px);">
                    <div class="filter-bar mb10">
                        <el-form :inline="true" @submit.native.prevent="submitSearch">
                            <el-form-item label="推广：">
                                <el-input v-model="tempQuery.search" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="推广名称、ID、内容" style="width: 220px;">
                                    <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="媒体：">
                                <ESelect v-model="queryData.plat_ids" multiple collapse-tags @change="submitSearch" clearable placeholder="全部媒体" style="width: 150px;">
                                    <el-option v-for="item in platList"
                                               :label="item.name"
                                               :value="item.id"
                                               :key="item.id">{{item.name}}
                                    </el-option>
                                </ESelect>
                            </el-form-item>
                            <el-form-item label="绑定状态：" prop="status">
                                <el-select v-model="queryData.status" @change="submitSearch" clearable placeholder="全部" style="width: 120px;">
                                    <el-option label="全部" value="">全部</el-option>
                                    <el-option label="正常" value="1"></el-option>
                                    <el-option label="停用" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="特殊产品：" prop="status">
                                <div slot="label">
                                    <el-popover
                                        placement="top-start"
                                        title=""
                                        width="400"
                                        trigger="hover">
                                        <span slot="reference">特殊产品<i class="el-icon-question"></i>：</span>

                                        <ul class="pl20" style="list-style: disc;">
                                            <li>此处查询与权限无关，若存在即显示，可能因为权限原因无法显示绑定的全部客户。</li>
                                            <li>多个启用客户：一个产品绑定了多个客户，且均为启用状态。</li>
                                            <li>多个绑定客户：一个产品绑定了多个客户，无论是否启用。</li>
                                            <li>全部停用：产品绑定的客户均为停用状态。</li>
                                        </ul>
                                    </el-popover>
                                </div>
                                <el-select v-model="queryData.special_app" @change="submitSearch" clearable placeholder="全部" style="width: 150px;">
                                    <el-option label="全部" value="">全部</el-option>
                                    <el-option label="多个启用客户" value="1"></el-option>
                                    <el-option label="多个绑定客户" value="2"></el-option>
                                    <el-option label="全部停用" value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="操作人：">
                                <ESelect :value="queryData.operator_ids" @change="changeUserId" filterable multiple collapse-tags clearable placeholder="搜索或下拉选择" style="width: 150px;">
                                    <el-option value="all-option">全选</el-option>
                                    <el-option v-for="item in operatorList" :label="item.operator" :value="item.operator_id" :key="item.operator_id">
                                        {{item.operator}}
                                    </el-option>
                                </ESelect>
                            </el-form-item>
                            <el-form-item label="操作时间：">
                                <el-date-picker
                                    v-model="tempQuery.range_time"
                                    @change="submitSearch"
                                    style="width: 220px"
                                    type="daterange"
                                    align="center"
                                    unlink-panels
                                    :picker-options="pickerOptions"
                                    value-format="yyyy-MM-dd"
                                    range-separator="~"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="table-tool-bar clear-both">
                        <div class="fl">
                            <el-button type="primary" @click="showBatchBindModal" v-if="pageFuncNames.includes('bind_app')" size="mini" class="mr20" v-matomo="{behaviorCategory: '客户产品管理',name: '绑定产品' }">绑定产品</el-button>
                            <el-button type="success" :disabled="dataSelected.length<=0" @click="batchEnable" v-if="pageFuncNames.includes('enable')" :loading="batchEnableLoading" size="mini" v-matomo="{behaviorCategory: '客户产品管理',name: '启用' }">启用</el-button>
                            <el-button type="danger" :disabled="dataSelected.length<=0" @click="batchDisable" v-if="pageFuncNames.includes('disable')" :loading="batchDisableLoading" size="mini" class="mr20" v-matomo="{behaviorCategory: '客户产品管理',name: '停用' }">停用</el-button>
                            <el-button @click="exportData" :loading="exportLoading" size="mini" v-matomo="{behaviorCategory: '客户产品管理',name: '导出' }">导出</el-button>
                        </div>
                        <div class="fr">
                            <p v-if="unbindNum>0" class="inline-block relative top10">
                                <span class="text-color-error"><i class="icon iconfont icon-jt-tongzhi pr4 info-tip-icon"></i>当前有 {{unbindNum}} 个产品未绑定客户，请及时绑定！</span>
                                <el-link type="primary" class="mr20 vertical-bottom" @click="showUnbindListModal">立即查看</el-link>
                            </p>
                        </div>
                        <p class="tips text-color-gray pl10 mt4 fl full-w">已选中 {{dataSelected.length}} 条</p>
                    </div>
                    <div class="data-list mb20">
                        <div class="relative">
                            <div class="table-wrap absolute full-w">
                                <el-table
                                    ref="dataTable"
                                    :data="dataList"
                                    v-loading="dataLoading"
                                    @selection-change="selectionChange"
                                    tooltip-effect="dark"
                                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                                    :height="tableHeight"
                                    stripe
                                    style="width: 100%;">
                                    <el-table-column
                                        fixed="left"
                                        type="selection"
                                        align="center"
                                        width="55">
                                    </el-table-column>
                                    <el-table-column
                                        fixed="left"
                                        prop="subproject_name"
                                        label="推广名称"
                                        show-overflow-tooltip
                                        min-width="170">
                                    </el-table-column>
                                    <el-table-column
                                        prop="subproject_id"
                                        label="推广ID"
                                        show-overflow-tooltip
                                        min-width="90">
                                    </el-table-column>
                                    <el-table-column
                                        prop="subproject_content"
                                        label="推广内容"
                                        show-overflow-tooltip
                                        min-width="220">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.subproject_content||'--'}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="plat_name"
                                        label="归属媒体"
                                        show-overflow-tooltip
                                        min-width="100">
                                    </el-table-column>
                                    <el-table-column
                                        prop="status_name"
                                        label="绑定状态"
                                        align="center"
                                        min-width="100">
                                        <template slot-scope="scope">
                                            <span class="text-color-success" v-if="scope.row.status=='1'">启用</span>
                                            <span class="text-color-error" v-else-if="scope.row.status=='0'">停用</span>
                                            <span v-else>--</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="company_name"
                                        label="绑定客户"
                                        show-overflow-tooltip
                                        min-width="200">
                                    </el-table-column>
                                    <el-table-column
                                        prop="operator"
                                        label="最后操作人"
                                        min-width="100">
                                    </el-table-column>
                                    <el-table-column
                                        prop="operation_time"
                                        label="最后操作时间"
                                        min-width="140">
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        prop="action"
                                        align="center"
                                        label="操作"
                                        min-width="120">
                                        <template slot-scope="scope">
                                            <el-button type="success" v-if="pageFuncNames.includes('enable')&&scope.row.status=='0'" @click="enableCustomerApp(scope.row)" :loading="scope.row.enableLoading" size="mini" class="action-btn">启用</el-button>
                                            <el-button type="danger" v-if="pageFuncNames.includes('disable')&&scope.row.status=='1'" @click="disableCustomerApp(scope.row)" :loading="scope.row.disableLoading" size="mini" class="action-btn">停用</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="page-bar tac mt10">
                                    <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page.sync="queryData.pn"
                                        :page-sizes="[30, 50,100]"
                                        :pager-count="5"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="totalCnt">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <UnbindListModal ref="unbindListModal" :is-disabled="!pageFuncNames.includes('bind_new_app')" :plat-list="platList" @update="updateUnbindData"/>
            <BatchBindModal ref="batchBindModal" :customer-data="activeCustomer" :app-list="dataSelected" @close="updateUnbindData" />
            <EnableResultModal ref="enableResultModal" :data-list="enableRowList" @confirm="confirmEnableApp"></EnableResultModal>
            <DisableResultModal ref="disableResultModal" @confirm="confirmDisableApp"></DisableResultModal>

        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>可在此页面维护客户和产品之间的对应关系，为投放进行底层能力建设。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import CompanyListCard from './components/companyListCard';
    import UnbindListModal from './modal/unbindListModal';
    import BatchBindModal from './modal/batchBindModal';
    import EnableResultModal from './modal/enableResultModal';
    import DisableResultModal from './modal/disableResultModal';
    import API from '@/api/baseInfo/customerApp.js';
    import matomoFun from "@/utils/matomo.js";

    export default {
        name: "CustomerAppPage",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            CompanyListCard,
            UnbindListModal,
            BatchBindModal,
            EnableResultModal,
            DisableResultModal,
        },
        data(){
            return {
                tempQuery:{
                    search:'',
                    range_time:'',
                },
                queryData:{
                    search:'',
                    plat_ids:[],
                    status:'',
                    special_app:'',
                    operator_ids:[],
                    range_time:'',
                    pn:1,
                    rn:30,
                },
                customerData:{
                    customer_id:'',
                    company_name:'',
                },
                tableHeight:300,
                totalCnt:0,
                operatorList:[],
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                    shortcuts:[
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                // 本周：自然周，周一到周日
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let weekDay = date.getDay();
                                let endDate = year+'-'+month+'-'+day;
                                let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                    ]
                },
                dataSelected:[],
                dataList:[],
                dataLoading:false,
                unbindNum:0,
                activeCustomer:{},
                batchEnableLoading:false,
                batchDisableLoading:false,

                enableRowList:[],
                enableRowType:'',
                exportLoading:false,
            }
        },
        computed:{
            ...mapState({
                sidebarOpened:state => state.app.sidebar.opened,
            }),
            platList(){
                return this.allowedPlatList.filter(item=>+item.id<=3||item.id==7 ||item.id==10 ||item.id==11);
            }
        },
        created(){
            this.getOperatorList();
            this.getUnbindNum();
            this.submitSearch();
        },
        mounted(){
            window.addEventListener("resize", this.calcTableHeight);
            this.calcTableHeight();
        },
        watch:{
            sidebarOpened(){
                setTimeout(()=>{
                    this.calcTableHeight();
                },100)
            },
        },
        beforeDestroy(){
            window.removeEventListener("resize", this.calcTableHeight);
        },
        methods:{
            calcTableHeight(){
                let $filterBar = document.querySelector('.filter-bar');
                let filterBarHeight = $filterBar?$filterBar.clientHeight:0;
                let height = window.innerHeight - 70 - filterBarHeight - 45 - 52 - 20;
                this.$nextTick(()=>{
                    this.tableHeight = height;
                })
            },
            updateUnbindData(){
                // 更新未绑定客户数量
                this.getUnbindNum();
                // 更新列表数据
                this.getDataList();
                // 更新客户list
                this.$refs.companyListCard.getDataList();
            },
            changeCustomer(item){
                console.log('changeCustomer',item);
                this.activeCustomer = item;
                this.submitSearch();
            },
            getOperatorList(){
                API.getOperatorList().then(res=>{
                    this.operatorList = res.data||[];
                },err=>{
                    console.log('getOperatorList err',err);
                    this.$message.error(err.info||'请求失败');
                    this.operatorList = [];
                })
            },
            getUnbindNum(){
                API.getUnbindNum().then(res=>{
                    let resData = res.data||{};
                    this.unbindNum = resData.unbind_num||0;
                })
            },
            submitSearch(){
                console.log('submitSearch');
                matomoFun.trackEvent('客户产品管理', '点击', '筛选');
                this.queryData.pn = 1;
                this.queryData.search = this.tempQuery.search;
                this.queryData.range_time = this.tempQuery.range_time?this.tempQuery.range_time.join('/'):'';
                this.getDataList();
            },
            changeUserId(val){
                if(val.includes('all-option')){
                    this.queryData.operator_ids = this.operatorList.map(item=>item.operator_id);
                }else{
                    this.queryData.operator_ids = val;
                }
                this.submitSearch();
            },
            getDataList(){
                this.dataLoading = true;
                API.getCustomerAppList({
                    customer_id: this.activeCustomer.customer_id,
                    search: this.queryData.search,
                    plat_ids: this.queryData.plat_ids.join(','),
                    status: this.queryData.status,
                    special_app: this.queryData.special_app,
                    operator_ids: this.queryData.operator_ids.join(','),
                    range_time: this.queryData.range_time,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = (resData.list||[]).map(item=>{
                        item.disableLoading = false;
                        item.enableLoading = false;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            selectionChange(val){
                this.dataSelected = val.map(item => item);
            },
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn = val;
                this.getDataList();
            },
            showUnbindListModal(){
                this.$refs.unbindListModal.showModal();
            },
            showBatchBindModal(){
                console.log('showBatchBindModal');
                this.$refs.batchBindModal.showModal();
            },
            batchEnable(){
                console.log('batch',this.dataSelected);
                if(this.dataSelected.length<=0) return false;

                let availableData = this.dataSelected.filter(item=>item.status=='0');
                if(availableData.length<=0) return this.$message.error('所选产品已经是启用状态');

                this.enableRowType = 'batch';
                this.enableRowList = [...availableData];
                this.batchEnableLoading = true;
                API.enableCustomerApp({
                    plat_id_app_id_customer_id:availableData.map(item=>`${item.plat_id}-${item.subitem_id}-${item.customer_id}`)
                }).then(res => {
                     this.batchEnableLoading = false;
                    console.log('enableCustomerApp',res);
                    let resData = res.data||[];
                    if(resData.length>0){
                        this.$refs.enableResultModal.showModal(resData);
                    }else{
                        this.$message.success(res.info||'操作成功');
                        this.getDataList();
                    }
                }, (err) => {
                     this.batchEnableLoading = false;
                    console.log('enableCustomerApp err',err);
                    this.enableRowList = [];
                    this.$message.error(err.info||'操作失败');
                });
            },
            batchDisable(){
                console.log('batch',this.dataSelected);
                if(this.dataSelected.length<=0) return false;

                let availableData = this.dataSelected.filter(item=>item.status=='1');
                if(availableData.length<=0) return this.$message.error('所选产品已经是停用状态');

                this.batchDisableLoading = true;
                API.disableCustomerApp({
                    plat_id_app_id_customer_id:availableData.map(item=>`${item.plat_id}-${item.subitem_id}-${item.customer_id}`)
                }).then(res => {
                     this.batchDisableLoading = false;
                    console.log('disableCustomerApp',res);
                    let resData = res.data||[];
                    if(resData.length>0){
                        this.$refs.disableResultModal.showModal(resData);
                    }else{
                        this.$confirm('<div><p>您确认要停用该客户的绑定关系吗?</p></div>','提示',{
                            confirmButtonText: '停用',
                            cancelButtonText: '取消',
                            type: 'warning',
                            confirmButtonClass:'danger-button',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            matomoFun.trackEvent('客户产品管理', '点击', '停用(提交)');
                            this.batchDisableLoading = true;
                            API.disableCustomerApp({
                                plat_id_app_id_customer_id:availableData.map(item=>`${item.plat_id}-${item.subitem_id}-${item.customer_id}`),
                                confirm:'1',
                            }).then(res1=>{
                                this.getDataList();
                                console.log('disableCustomerApp',res1);
                                this.$message.success(res1.info||'操作成功');
                                this.batchDisableLoading = false;
                            },err1=>{
                                this.batchDisableLoading = false;
                                console.log('disableCustomerApp err',err1);
                                this.$message.error(err1.info||'操作失败');
                            })
                        }).catch(()=>{
                            console.log('取消');
                            matomoFun.trackEvent('客户产品管理', '点击', '停用(取消)');
                        });
                    }
                }, (err) => {
                     this.batchDisableLoading = false;
                    console.log('disableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            enableCustomerApp(row){
                console.log('enableCustomerApp',row);
                row.enableLoading = true;
                this.enableRowType = '';
                this.enableRowList = [row];

                API.enableCustomerApp({
                    plat_id_app_id_customer_id:[`${row.plat_id}-${row.subitem_id}-${row.customer_id}`]
                }).then(res => {
                    let resData = res.data||[];
                    row.enableLoading = false;
                    if(resData.length>0){

                        this.$refs.enableResultModal.showModal(resData);
                    }else{
                        this.$message.success(res.info||'操作成功');
                        this.enableRowList = [];
                        this.getDataList();
                    }
                }, (err) => {
                    row.enableLoading = false;
                    console.log('enableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            confirmEnableApp(val){
                let isBatch = this.enableRowType =='batch';
                console.log('confirmEnableApp',isBatch);
                if(isBatch){
                    this.batchEnableLoading = true;
                }
                this.enableRowList.forEach(row=>{
                    let rowItem = this.dataList.find(item=>item.plat_id==row.plat_id&&item.subitem_id==row.subitem_id);
                    this.$set(rowItem,'enableLoading',true);
                });
                API.enableCustomerApp({
                    plat_id_app_id_customer_id:this.enableRowList.map(row=>`${row.plat_id}-${row.subitem_id}-${row.customer_id}`),
                    confirm:val,
                }).then(res => {
                    this.$message.success(res.info||'操作成功');
                    if(isBatch){
                        this.batchEnableLoading = false;
                    }
                    this.getDataList();
                }, (err) => {
                    if(isBatch){
                        this.batchEnableLoading = false;
                    }
                    this.enableRowList.forEach(row=>{
                        let rowItem = this.dataList.find(item=>item.plat_id==row.plat_id&&item.subitem_id==row.subitem_id);
                        this.$set(rowItem,'enableLoading',false);
                    });
                    console.log('enableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            confirmDisableApp(val){
                this.batchDisableLoading = true;
                let availableData = this.dataSelected.filter(item=>item.status=='1');
                API.disableCustomerApp({
                    plat_id_app_id_customer_id:availableData.map(row=>`${row.plat_id}-${row.subitem_id}-${row.customer_id}`),
                    confirm:val,
                }).then(res => {
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                    this.batchDisableLoading = false;
                }, (err) => {
                    this.batchDisableLoading = false;
                    // this.dataSelected.forEach(row=>{
                    //     let rowItem = this.dataList.find(item=>item.plat_id==row.plat_id&&item.subitem_id==row.subitem_id);
                    //     this.$set(rowItem,'enableLoading',false);
                    // });
                    console.log('enableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            disableCustomerApp(row){
                console.log('disableCustomerApp',row);
                row.disableLoading = true;
                API.disableCustomerApp({
                    plat_id_app_id_customer_id:[`${row.plat_id}-${row.subitem_id}-${row.customer_id}`]
                }).then(res => {
                    row.disableLoading = false;

                    let resData = res.data||[];
                    let htmlStr = '';

                    if(resData.length>0){
                        htmlStr = '<div><p>当前产品已无其他启用的绑定客户，您确认要停用吗?</p></div>';
                    }else{
                        htmlStr = '<div><p>您确认要停用该客户的绑定关系吗?</p></div>';
                    }

                    this.$confirm(htmlStr,'提示',{
                        confirmButtonText: '停用',
                        cancelButtonText: '取消',
                        type: 'warning',
                        confirmButtonClass:'danger-button',
                        dangerouslyUseHTMLString: true,
                        customClass:'wide-confirm-box-550',
                    }).then(()=>{
                        row.disableLoading = true;
                        API.disableCustomerApp({
                            plat_id_app_id_customer_id:[`${row.plat_id}-${row.subitem_id}-${row.customer_id}`],
                            confirm:'1',
                        }).then(res1=>{
                            this.getDataList();
                            console.log('disableCustomerApp',res1);
                            this.$message.success(res1.info||'操作成功');
                        },err1=>{
                            row.disableLoading = false;
                            console.log('disableCustomerApp err',err1);
                            this.$message.error(err1.info||'操作失败');
                        })
                    }).catch(()=>{
                        console.log('取消');
                    });
                }, (err) => {
                    row.disableLoading = false;
                    console.log('disableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            exportData(){
                this.exportLoading = true;
                API.getCustomerAppList({
                    export:'1',
                    customer_id: this.activeCustomer.customer_id,
                    search: this.queryData.search,
                    plat_ids: this.queryData.plat_ids.join(','),
                    status: this.queryData.status,
                    special_app: this.queryData.special_app,
                    operator_ids: this.queryData.operator_ids.join(','),
                    range_time: this.queryData.range_time,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    this.exportLoading = false;
                    this.$message.success(res.info||'操作成功');
                }, (err) => {
                    this.exportLoading = false;
                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            message: errData.join('；'),
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .wrap {
        display: flex;
    }

    .left {
        width: 260px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

    }

    .right {
        background-color: #fff;
        margin-left: 10px;
        flex: 1;
        .filter-bar{
            background-color: #f8f8f9;
            padding: 12px 20px 0;
            border-radius: 5px;
            ::v-deep .el-form-item{
                margin-bottom: 12px;
            }
        }
        .top10{
            top:10px;
        }
        .table-wrap::v-deep .el-table{
            background-color: #f8f8f9;
            .el-button.is-disabled {
                color: #999!important;
            }
        }

        .vertical-bottom{
            vertical-align: bottom;
        }
        .action-btn{
            padding: 5px 10px;
        }
        .no-pointer{
            cursor: default;
        }



        .info-tip-icon{
            font-weight: bold;
            font-size: 24px;
            vertical-align: middle;
        }

        ::v-deep .el-table__cell{
            padding: 5px 0;
        }
    }

</style>
